module.exports = __webpack_public_path__ + "img/the-right-light.100bea61.png";